import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { noop } from 'lodash';
import React from 'react';
import { useForm } from 'react-hook-form';
import Api from '~/api';
import { registerViewer } from '~/api/NewViewer';
import { RELATIONSHIP_OPTIONS } from '~/constants/general';
import { Input, Mobile } from '~/elements/Input';
import Select from '~/elements/Select';
import { FieldHidden, FieldMandatory } from '~/types/common';
import { hiddenField, mandatoryField } from '~/utils/featureToggle';
import { TermsAndConditions } from '.';
import styles from './registerForm.module.css';
import schema from './contactCaptureForm.schema';
import Loader from '~/elements/Loader';
import { useFingerPrint } from '~/components/FingerPrintProvider';
import { stripLeadingPlus } from '~/utils/validation';
const ContactCaptureForm = (props) => {
    const [loading, setLoading] = React.useState(false);
    const { country, fingerprint, verifyUser } = process.env.NODE_ENV === 'test'
        ? {
            country: 'NZ',
            fingerprint: 'mockFingerPrint',
            verifyUser: noop,
        }
        : useFingerPrint();
    const FULLNAME_MANDATORY = mandatoryField(FieldMandatory.fullname_mandatory);
    const EMAIL_MANDATORY = mandatoryField(FieldMandatory.email_mandatory);
    const MOBILE_MANDATORY = mandatoryField(FieldMandatory.mobile_mandatory);
    const MOBILE_HIDDEN = hiddenField(FieldHidden.mobile_hidden);
    const RELATIONSHIP_MANDATORY = mandatoryField(FieldMandatory.relationship_mandatory);
    const RELATIONSHIP_HIDDEN = hiddenField(FieldHidden.relationship_hidden);
    const POSTCODE_MANDATORY = mandatoryField(FieldMandatory.postcode_mandatory);
    const POSTCODE_HIDDEN = hiddenField(FieldHidden.postcode_hidden);
    const { control, handleSubmit, setValue } = useForm({
        resolver: yupResolver(schema(country ?? 'NZ')),
    });
    const IS_USA = country === 'US';
    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        Api.Analytics.submitOgrForm();
        try {
            await registerViewer(Number(props.event.id), fingerprint, data.fullName, data.email, stripLeadingPlus(data.mobile, data.mobileCountry), data.relationship || '', data.zip || '');
            verifyUser();
            setLoading(false);
            props.onRegister();
        }
        catch (error) {
            setLoading(false);
        }
    });
    const updateMobile = (value, mobileCountry) => {
        setValue('mobile', value, {
            shouldDirty: true,
        });
        setValue('mobileCountry', mobileCountry, {
            shouldDirty: true,
        });
    };
    return (_jsxs("form", { className: styles.form, onSubmit: onSubmit, children: [_jsx(Input, { label: "Your Name", name: "fullName", control: control, isRequired: FULLNAME_MANDATORY }), _jsx(Input, { label: "Email", name: "email", type: "email", control: control, isRequired: EMAIL_MANDATORY }), !MOBILE_HIDDEN && (_jsx(Mobile, { label: "Mobile Number", name: "mobile", control: control, isRequired: MOBILE_MANDATORY, defaultCountry: country ? country.toLowerCase() : 'nz', updateMobile: updateMobile })), !RELATIONSHIP_HIDDEN && (_jsx(Select, { label: "Relationship", name: "relationship", control: control, options: RELATIONSHIP_OPTIONS, isRequired: RELATIONSHIP_MANDATORY, placeholder: "Select your relationship" })), !POSTCODE_HIDDEN && (_jsx(Input, { label: IS_USA ? 'Zip Code' : 'Postcode', name: "zip", control: control, isRequired: POSTCODE_MANDATORY })), _jsx(Input, { label: "Terms and Conditions", name: "tandc", control: control, type: "checkbox", children: _jsx(TermsAndConditions, {}) }), _jsx("button", { className: styles.registerButton, disabled: loading, children: loading ? _jsx(Loader, { size: 24, color: "white" }) : 'Register to Watch' })] }));
};
export default ContactCaptureForm;
